import {map} from 'rxjs/operators';

import {Router} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {Keys, StorageService} from '../service/storage.service';
import {DocumentType} from '../model/document-type.model';
import {NomineeService} from '../service/nominee.service';
import {HttpClient} from '@angular/common/http';
import { FinzyVersion } from '../model/common/investment-product';
import { ConfigService } from '../service/config.service';

@Component({
    selector: 'app-lendersummary',
    templateUrl: './lendersummary.component.html',
    styleUrls: ['./lendersummary.component.css'],
    providers: [ApiServiceService, NomineeService]
})

export class LendersummaryComponent implements OnInit {
    result2: any;
    result: any;
    document: string;
    docno: string;
    pan: string;
    name: string;
    mobile_no: string;
    result3: any;
    result4: any;
    lender_application_complete: number;
    lender_status: string;
    hideSubmit = true;
    loader = false;
    bank_name: string;
    account_no: string;
    bank_ifsc: string;
    nomineeName: string;
    allStepsComplete: boolean;
    errorMsg: string;
    activeFinzyVersion: string;

    constructor(private http: HttpClient, private router: Router, private ref: ApiServiceService,
                private storageService: StorageService, public analyticsTracker: AnalyticsTracker, public nomineeService: NomineeService,
                private configService: ConfigService) {

        this.allStepsComplete = true;
        const investmentPreferences = this.storageService.getItem(Keys.INVESTMENT_PREFERENCES);
        if (investmentPreferences && investmentPreferences !== 'true') {
            this.allStepsComplete = false;
            this.showError('Please ensure all required details in the investment preference step are filled to submit your application');
        }
    }

    async startInvesting(event) {
        if (this.allStepsComplete) {
            this.analyticsTracker.trackConversion();
            this.hideSubmit = false;
            this.loader = true;
            if (this.lender_status === 'submitted') {
                this.hideSubmit = true;
                this.loader = false;
                if (this.activeFinzyVersion === FinzyVersion.FINZY_V2) {
                    this.router.navigate(['/investment-initial']);
                } else {
                    this.router.navigate(['/lenderinitial']);
                }
            } else {
                this.result4 = this.http.post<any>(this.ref.baseURL() + 'updateLenderApplication', {
                    lender_id: this.storageService.getItem(Keys.LENDER_ID),
                    profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                    token: this.storageService.getItem(Keys.TOKEN)
                }).subscribe((result4) => {
                        this.result4 = result4;
                        if (this.result4.status === 'success') {
                            this.hideSubmit = true;
                            this.loader = false;
                            this.storageService.saveItem(Keys.INVEST_SUBMIT, 'true');
                            if (this.activeFinzyVersion === FinzyVersion.FINZY_V2) {
                                this.router.navigate(['/investment-initial']);
                            } else {
                                this.router.navigate(['/lenderinitial']);
                            }
                        } else {
                            this.hideSubmit = true;
                            this.loader = false;
                            return false;
                        }

                    });
            }
        }
    }

    async ngOnInit() {
        this.activeFinzyVersion = this.configService.getActiveFinzyVersion();
        window.scrollTo(0, 0);
        if (this.storageService.getItem(Keys.UPLOAD_DOCUMENTS) == 'true') {
            this.result = this.http.post<any>(this.ref.baseURL() + 'getProfileDetails', {
                profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                token: this.storageService.getItem(Keys.TOKEN)
            }).subscribe((result) => {
                    this.result = result;
                    if (this.result.status === 'Success') {
                        this.pan = this.result.pan_no;
                        this.mobile_no = this.result.mobile_no;
                        this.name = this.result.response.name;
                    }
                });

            this.result2 = this.http.post<any>(this.ref.baseURL() + 'getLenderInfoDetails',
                {
                    lender_id: this.storageService.getItem(Keys.LENDER_ID),
                    profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                    token: this.storageService.getItem(Keys.TOKEN)
                }).subscribe((result2) => {
                    this.result2 = result2;
                    if (this.result2.status === 'success') {
                        this.lender_application_complete = this.result2.lender_info.lender_application_complete;
                        this.lender_status = this.result2.lender_info.lender_status;
                        this.bank_name = this.result2.lender_info.bank_account.bank_name;
                        this.account_no = 'XXXXXXXXXX' + this.result2.lender_info.bank_account.account_no.substr(-4);
                        this.bank_ifsc = this.result2.lender_info.bank_account.ifsc;
                        this.docno = this.result2.lender_info.correspondence_address.address_proof.number;
                        const addressProofType = this.result2.lender_info.correspondence_address.address_proof.type;

                        // Address Proof number is mandatory except if the proof type is Aadhaar
                        if (!this.docno && addressProofType !== DocumentType.Aadhaar) {
                            this.router.navigateByUrl('invest/residence-info');
                        }

                        if (addressProofType === DocumentType.Aadhaar) {
                            this.document = 'AADHAAR';
                        } else if (addressProofType === 'passport') {
                            this.document = 'PASSPORT';
                        } else if (addressProofType === 'drivinglicense') {
                            this.document = 'DRIVING LICENSE';
                        } else if (addressProofType === 'voterid') {
                            this.document = 'VOTER ID';
                        } else if (addressProofType === 'lpg') {
                            this.document = 'LPG NUMBER';
                        } else if (addressProofType === 'telephone') {
                            this.document = 'TELEPHONE NUMBER';
                        } else if (addressProofType === 'electricity') {
                            this.document = 'ELECTRICITY NUMBER';
                        }
                    }
                });
            await this.fetchNomineeDetails();
        }
    }

    private async fetchNomineeDetails() {
        const userId = this.storageService.getItem(Keys.PROFILE_ID);
        const nominee = await this.nomineeService.findNomineeByUserId(userId);
        if (nominee) {
            this.nomineeName = nominee.name;
        }
    }

    private showError(msg: string) {
        this.errorMsg = msg;
    }
}
